import React, {FC, RefObject} from "react";
import {GridActionsCellItem, GridColDef} from "@mui/x-data-grid";
import {formatTime} from "@/helper/method";
import {ProTable} from "@/widget/ProTable/ProTable";
import {SiteAccountPageVO, useQuerySiteAccountPage} from "@/service/siteAccount.s";
import {get} from "lodash";
import Button from "@mui/material/Button";
import {useGlobalActions} from "@/store/global.c";
import {DictPO} from "@/model/system";
import Stack from "@mui/material/Stack";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import Typography from "@mui/material/Typography";
import {GridApiCommunity} from "@mui/x-data-grid/internals";
import InsertLinkOutlinedIcon from '@mui/icons-material/InsertLinkOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import {WriteSiteAccount, WriteSiteAccountType} from "@/widget/SiteAccount/WriteSiteAccount";
import NoResultsOverlay from "@/widget/NoResultsOverlay/NoResultsOverlay";
import {useCallDeletes} from "@/service/common.s";

export interface SiteTableProps {
    customerId?: number
    tag?: number;
    disabled?: boolean;
    checkboxSelection?: boolean;
    options?: DictPO[]
}

export const SiteAccountTable: FC<SiteTableProps> = ({tag, customerId, disabled = true, options, checkboxSelection}) => {
    const {mutateAsync: siteAccountPageMutate, data: siteAccountPageData, isPending: siteAccountPagePending} = useQuerySiteAccountPage()
    const {setDialogModal, setToast} = useGlobalActions()
    const {mutateAsync: callDeletesMutate} = useCallDeletes();

    const columns: GridColDef<SiteAccountPageVO>[] = [
        {
            field: "siteName",
            headerName: "网站名称",
            headerAlign: "left",
            align: "left",
            flex: 0.6
        },
        {
            field: "link",
            headerName: "网址",
            headerAlign: "center",
            align: "center",
            minWidth: 120,
            flex: 0.6
        },
        {
            field: "username",
            headerName: "账号",
            headerAlign: "center",
            align: "center",
            flex: 0.4
        },
        {
            field: "password",
            headerName: "密码",
            headerAlign: "center",
            align: "center",
        }, {
            field: "actions",
            type: "actions",
            headerName: "操作",
            getActions: ({row: {link}}) => [<GridActionsCellItem
                icon={<EditOutlinedIcon/>}
                label="修改"
                color={'default'}
                onClick={() => {
                }}
            />, <GridActionsCellItem
                icon={<InsertLinkOutlinedIcon/>}
                label="跳转"
                color={'default'}
                onClick={() => {
                    window.open(link)
                }}
            />]
        }]

    const onWriteSiteAccount = ({title, onSearch, options}: WriteSiteAccountType) => {
        setDialogModal({header: title, maxWidth: 'xs', body: <WriteSiteAccount customerId={customerId!} options={options}/>, open: true, onSearch})
    }

    const onDeleteSiteAccount = async (apiRef: RefObject<GridApiCommunity | null>) => {
        const selectedRows = apiRef?.current?.getSelectedRows();
        if (selectedRows?.size != 1) {
            setToast({open: true, message: "请选择一条数据", severity: "warning", variant: 'standard'})
            return
        }
        const row = selectedRows?.entries()?.next()
        const id = get(row, 'value[0]', 0) as number
        const result = await callDeletesMutate({
            ids: [id],
            url: "/siteAccount/deleteSiteAccounts",
        });
        if (result.code == 0) {
            await refetchData()
            setToast({open: true, message: result.msg, severity: "success", variant: 'standard'})
        } else {
            setToast({open: true, message: result.msg, severity: "error", variant: 'standard'})
        }
    }

    const refetchData = async () => {
        await siteAccountPageMutate({current: 1, size: 5, customerId})
    }

    return <ProTable<SiteAccountPageVO> checkboxSelection={checkboxSelection} columnHeaderHeight={40} loading={siteAccountPagePending}
                                        onSearch={(params) => siteAccountPageMutate({...params, customerId, tag})}
                                        data={siteAccountPageData?.data} pageSize={5} showToolbar={false}
                                        columns={columns}
                                        noResults={() => <NoResultsOverlay label={'点击添加账号'} kind={'doc'} onClick={() => {
                                            !disabled && onWriteSiteAccount({
                                                title: '新增网报账号', options: options || [], onSearch:
                                                    () => refetchData()
                                            })
                                        }}/>}
                                        autoHeight={false}
                                        feet={{
                                            hidden: get(siteAccountPageData, "data.total", 0) == 0,
                                            custom: true,
                                            leftFunc: (apiRef: RefObject<GridApiCommunity | null>) => {
                                                return <Stack direction={'row'} spacing={1.3} width={'100%'}>
                                                    <Button
                                                        onClick={() => {
                                                            onWriteSiteAccount({
                                                                title: '新增网报账号',
                                                                options: options || [],
                                                                onSearch: () => refetchData()
                                                            })
                                                        }}
                                                        disabled={disabled}
                                                        startIcon={<AddOutlinedIcon color={'info'}/>} variant={'outlined'}
                                                        size={'small'}
                                                        color={'inherit'}><Typography color={'info'} variant={'caption'}>添加账号</Typography></Button>
                                                    <Button
                                                        onClick={async () => {
                                                            await onDeleteSiteAccount(apiRef)
                                                        }}
                                                        disabled={disabled}
                                                        startIcon={<DeleteOutlineOutlinedIcon color={'error'}/>} variant={'outlined'}
                                                        size={'small'}
                                                        color={'error'}><Typography color={'error'} variant={'caption'}>刪除账号</Typography></Button>
                                                </Stack>
                                            }
                                        }}
    />
}